// extracted by mini-css-extract-plugin
export default {"scrolling":"OverlayArea_scrolling__1X6ed","expanding":"OverlayArea_expanding__hTfBU"};